import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7021e05d"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " 固定资产列表 ", -1))
const _hoisted_2 = /*#__PURE__*/_createTextVNode("搜索")
const _hoisted_3 = { class: "d-flex d-flex-row-reverse" }
const _hoisted_4 = { class: "dialog-footer" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("取 消")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("确 定 ")

import Api from "@/http/modules";
import tbMix from "@/global_mixin/tableMixin";
import {reactive, ref, watch} from "vue";


export default /*#__PURE__*/_defineComponent({
  props: {
    show: null,
    orgList: null,
    companyList: null,
    categoryList: null,
    filterBind: { type: Boolean },
    status: null
  },
  emits: ['select'],
  setup(__props: any, { emit }) {

const props = __props as {
  show: Boolean,
  orgList: any[],
  companyList: any[],
  categoryList: any[],
  filterBind?: boolean,
  status?: string[]|null,

}

const {
  "POST/office/asset/fixed_list": fixedAssetListApi,
} = Api


const fixAssetTbEle = ref()
const {
  MI_tableData, fetchData, page, size, MI_total, MI_pageChange,
  MI_sizeChange, MI_identify, MI_params, MI_modifyForm, MI_height
} = new tbMix(fixedAssetListApi)
const dialogInfo = reactive({
  isShow: false,
  loading: false
})
const formData = reactive({
  orgId: null,
  companyId: null,
  categoryNo: null,
  filterBind: props.filterBind,
  status: props.status && props.status.length > 0 ? props.status : null
})

watch(() => props.show, (cur, old) => {
  if (cur) {
    formData.orgId = null
    formData.companyId = null
    formData.categoryNo = null
    formData.filterBind = props.filterBind
    formData.status = props.status && props.status.length > 0 ? props.status : null
    fetchData(formData)
    dialogInfo.isShow = true
    setTimeout(() => {
      fixAssetTbEle.value.clearSelection()
    }, 10)
  }
})
const selected = ref<any[]>([])
const handleSelectionChange = (list: any[]) => {
  selected.value = list
}

const onClick = () => {
  emit("select", selected.value)
  dialogInfo.isShow = false
}
const searchAssets = () => {
  page.value=1;
  fetchData(formData)
}


return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    class: "fixedAssetListDialog",
    modelValue: _unref(dialogInfo).isShow,
    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(dialogInfo).isShow) = $event)),
    draggable: "",
    width: "1200px"
  }, {
    header: _withCtx(() => [
      _hoisted_1
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_el_button, {
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_unref(dialogInfo).isShow=false))
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: onClick,
          loading: _unref(dialogInfo).loading,
          disabled: _unref(dialogInfo).loading
        }, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        }, 8, ["loading", "disabled"])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createVNode(_component_el_form, {
          class: "fixedAssetListSearchForm",
          model: _unref(formData),
          "label-width": "90px",
          inline: true,
          ref: "searchEle",
          "label-position": "right"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "所属团队",
              prop: "orgId",
              class: "flex-1"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _unref(formData).orgId,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(formData).orgId) = $event)),
                  placeholder: "所属团队",
                  clearable: ""
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.orgList, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.id,
                        label: item.name,
                        value: item.id
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "所属公司:",
              prop: "companyId"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _unref(formData).companyId,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(formData).companyId) = $event)),
                  placeholder: "所属公司",
                  clearable: ""
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.companyList, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.id,
                        label: item.name,
                        value: item.id
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "资产类别:",
              prop: "companyId"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _unref(formData).categoryNo,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(formData).categoryNo) = $event)),
                  placeholder: "资产类别",
                  clearable: ""
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.categoryList, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.id,
                        label: item.name,
                        value: item.no
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: searchAssets
                }, {
                  default: _withCtx(() => [
                    _hoisted_2
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"]),
        _withDirectives((_openBlock(), _createBlock(_component_el_table, {
          ref_key: "fixAssetTbEle",
          ref: fixAssetTbEle,
          border: "",
          class: "mt-10",
          data: _unref(MI_tableData),
          "row-key": "id",
          "max-height": _unref(MI_height) - 100 + 'px',
          onSelectionChange: handleSelectionChange
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              type: "selection",
              width: "55",
              fixed: ""
            }),
            _createVNode(_component_el_table_column, {
              label: "所属团队",
              prop: "orgName",
              width: "120",
              "show-overflow-tooltip": ""
            }),
            _createVNode(_component_el_table_column, {
              label: "所属公司",
              prop: "companyName",
              width: "120",
              "show-overflow-tooltip": ""
            }),
            _createVNode(_component_el_table_column, {
              label: "资产编号",
              prop: "no",
              width: "200",
              "show-overflow-tooltip": ""
            }),
            _createVNode(_component_el_table_column, {
              label: "资产名称",
              prop: "name",
              width: "120",
              "show-overflow-tooltip": ""
            }),
            _createVNode(_component_el_table_column, {
              label: "规格型号",
              prop: "spec",
              width: "100",
              "show-overflow-tooltip": ""
            }),
            _createVNode(_component_el_table_column, {
              label: "电脑设备ID",
              prop: "deviceId",
              width: "120",
              "show-overflow-tooltip": ""
            }),
            _createVNode(_component_el_table_column, {
              label: "资产类别",
              prop: "categoryName",
              width: "100",
              "show-overflow-tooltip": ""
            }),
            _createVNode(_component_el_table_column, {
              label: "单位",
              prop: "unit",
              width: "60",
              "show-overflow-tooltip": ""
            }),
            _createVNode(_component_el_table_column, {
              label: "数量",
              prop: "count",
              width: "60",
              "show-overflow-tooltip": ""
            }),
            _createVNode(_component_el_table_column, {
              label: "使用状态",
              prop: "statusDesc",
              width: "105",
              "show-overflow-tooltip": ""
            })
          ]),
          _: 1
        }, 8, ["data", "max-height"])), [
          [_directive_loading, _unref(MI_identify)]
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_el_pagination, {
            disabled: _unref(MI_identify),
            background: "",
            small: "",
            total: _unref(MI_total),
            currentPage: _unref(page),
            "onUpdate:currentPage": _cache[3] || (_cache[3] = ($event: any) => (_isRef(page) ? (page).value = $event : null)),
            "page-size": _unref(size),
            "onUpdate:page-size": _cache[4] || (_cache[4] = ($event: any) => (_isRef(size) ? (size).value = $event : null)),
            class: "mt-10",
            "page-sizes": [10, 30, 50, 100, 300, 1000],
            layout: "sizes, prev, pager, next, total, jumper",
            onCurrentChange: _unref(MI_pageChange),
            onSizeChange: _unref(MI_sizeChange)
          }, null, 8, ["disabled", "total", "currentPage", "page-size", "onCurrentChange", "onSizeChange"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})